import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  Coupon,
  CouponBulkCreatePayload,
  CouponBulkUpdatePayload,
  CouponListResponse,
  CouponPayload,
} from '../models/coupon';

@Injectable({
  providedIn: 'root',
})
export class CouponService {
  constructor(private http: HttpClient) {}

  private readonly baseUrl = `${environment.apiUrl}/admin/coupons/`;

  listCoupons(filters?: {
    is_active?: string;
    name?: string;
    account_id?: number;
    trusted_only?: string;
    page?: number;
  }): Observable<CouponListResponse> {
    let params = new HttpParams();
    Object.entries(filters || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, String(value));
      }
    });
    return this.http.get<CouponListResponse>(this.baseUrl, { params });
  }

  get(id: number): Observable<Coupon> {
    return this.http.get<Coupon>(`${this.baseUrl}${id}/`);
  }

  create(payload: CouponPayload): Observable<Coupon> {
    return this.http.post<Coupon>(this.baseUrl, payload);
  }

  update(id: number, payload: CouponPayload): Observable<Coupon> {
    return this.http.put<Coupon>(`${this.baseUrl}${id}/`, payload);
  }

  bulkCreate(payload: CouponBulkCreatePayload): Observable<Coupon[]> {
    return this.http.post<Coupon[]>(`${this.baseUrl}bulk_create/`, payload);
  }

  bulkUpdate(payload: CouponBulkUpdatePayload): Observable<Coupon[]> {
    return this.http.patch<Coupon[]>(`${this.baseUrl}bulk_update/`, payload);
  }

  listPartnerCoupons(since: string, until: string): Observable<Coupon[]> {
    return this.http.get<Coupon[]>(
      `${this.baseUrl}partners/?since=${since}&until=${until}`
    );
  }
}
